import { Injectable } from '@angular/core';
import { IID_OL_CONTRATTO } from '@common/interfaces/interfaceData';
import { Topics } from '@common/interfaces/topics';
import { ActionService } from '../action/action.service';
import { CrudService } from '../crudService';
import { IIDolContrattoQuery } from './iidOlContratto.query';
import { IIDolContrattoStore } from './iidOlContratto.store';
import { IssueEntityStoreStrategy } from '../updateStoreStrategies';
@Injectable({
  providedIn: 'root'
})
export class IIDolContrattoService extends CrudService<IID_OL_CONTRATTO, IIDolContrattoStore, IIDolContrattoQuery> {
  constructor(
    protected store: IIDolContrattoStore,
    protected query: IIDolContrattoQuery,
    protected actionService: ActionService,
    protected updateStrategy: IssueEntityStoreStrategy) {
    super(
      Topics.IID_OL_CONTRATTO,
      store,
      query,
      actionService,
      updateStrategy,
    );
  }

}
